/* global document */
import { Component } from 'react';
import ReactDOM from 'react-dom';

import ContactForm from './ContactForm';

class Contact extends Component {
  render() {
    return ReactDOM.createPortal(
      <ContactForm />,
      document.getElementById('c7-constellation-contact')
    );
  }
}

export default Contact;
